// extracted by mini-css-extract-plugin
export default {"list":"RecommendedFoodList_list__PeSoM","item":"RecommendedFoodList_item__GSrQs","name":"RecommendedFoodList_name__BcSTs","calories":"RecommendedFoodList_calories__Uv0Ua"};